module.exports = __webpack_public_path__ + "static/media/diamond.4c1825f2.png";